export const translations = {
    uz: {
        // --- Header & Nav ---
        home: "Bosh sahifa",
        shop: "Do'kon",
        album: "Albom",
        about: "Biz haqimizda",
        services: "Xizmatlar",
        contact: "Aloqa",
        contactSubtitle: "Savollaringiz bormi? Biz sizga yordam berishga tayyormiz.",
        albumDesc: "Katalogdagi yangi modellar va xonadonlardagi pardalar galereyasi. Rasmni bosing — to'liq ko'rinish ochiladi.",
        albumMetaDesc: "Nuur Home mahsulotlari galereyasi va pardalar modellari albomi.",
        viewImage: "Rasmini ko'rish",
        namePlaceholder: "Ismingiz",
        emailPlaceholder: "email@misol.uz",
        phonePlaceholder: "+998...",
        messagePlaceholder: "Sizga qanday yordam bera olamiz?",
        categories: "Kategoriyalar",
        curtainAccessories: "Parda Aksessuarlari",
        cart: "Savat",
        login: "Kirish",
        register: "Ro'yxatdan o'tish",
        logout: "Chiqish",
        search: "Qidirish...",
        activeFilter: "Faol filter",
        allCategories: "Barcha kategoriyalar",
        noAccount: "Akkauntingiz yo'qmi? Yaratish",
        haveAccount: "Akkauntingiz bormi? Kirish",
        authSwitchPromptLogin: "Akkauntingiz yo'qmi?",
        authSwitchPromptRegister: "Akkauntingiz bormi?",
        loginSubmitting: "Kirish...",
        registerSubmitting: "Ro'yxatdan o'tilmoqda...",
        forgotPassword: "Parolni unutdingizmi?",
        resetPasswordTitle: "Parolni tiklash",
        resetPasswordHint:
            "Ro'yxatdan o'tgan email manzilingizni kiriting. Sizga parolni tiklash havolasi yuboriladi.",
        resetPasswordSent:
            "Agar bu email bilan hisob bo'lsa, pochtangizga tiklash havolasi yuborildi. Spam papkasini ham tekshiring.",
        resetPasswordSubmit: "Tiklash havolasini yuborish",
        recoveryNewPasswordTitle: "Yangi parol o'rnatish",
        recoveryNewPasswordHint:
            "Emaildagi havola orqali kirdingiz. Yangi parolni kiriting va saqlang.",
        backToLogin: "Kirishga qaytish",
        sending: "Yuborilmoqda...",

        // --- Auth ---
        changePassword: "Parolni o'zgartirish",
        newPassword: "Yangi parol",
        passwordMinLength: "Parol kamida 6 belgidan iborat bo'lishi kerak",
        name: "Ism",
        email: "Email",
        password: "Parol",
        confirmPassword: "Parolni tasdiqlang",
        country: "Davlat",
        selectCountry: "Davlatni tanlang",
        uzbekistan: "O'zbekiston",
        kazakhstan: "Qozog'iston",
        kyrgyzstan: "Qirg'iziston",
        tajikistan: "Tojikiston",
        turkmenistan: "Turkmaniston",
        turkey: "Turkiya",
        uae: "BAA (Amirliklar)",
        saudi_arabia: "Saudiya Arabistoni",
        qatar: "Qatar",
        kuwait: "Quvayt",
        oman: "Ummon",
        azerbaijan: "Ozarbayjon",
        russia: "Rossiya",
        china: "Xitoy",
        afghanistan: "Afg'oniston",
        armenia: "Armaniston",
        belarus: "Belarus",
        georgia: "Gruziya",
        india: "Hindiston",
        iran: "Eron",
        iraq: "Iroq",
        israel: "Isroil",
        jordan: "Iordaniya",
        lebanon: "Livan",
        mongolia: "Mo'g'uliston",
        pakistan: "Pokiston",
        palestine: "Falastin",
        syria: "Suriya",
        yemen: "Yaman",
        south_korea: "Janubiy Koreya",
        japan: "Yaponiya",
        vietnam: "Vyetnam",
        thailand: "Tailand",
        malaysia: "Malayziya",
        singapore: "Singapur",
        indonesia: "Indoneziya",
        uk: "Buyuk Britaniya",
        germany: "Germaniya",
        france: "Fransiya",
        italy: "Italiya",
        spain: "Ispaniya",
        netherlands: "Niderlandiya",
        switzerland: "Shveytsariya",
        poland: "Polsha",
        ukraine: "Ukraina",
        bangladesh: "Bangladesh",
        philippines: "Filippin",
        enterName: "Ismingizni kiriting",
        passwordPlaceholder: "Parolni kiriting (kamida 6 belgi)",
        confirmPasswordPlaceholder: "Parolni qayta kiriting",
        passwordMismatch: "Parollar mos kelmadi",
        showPassword: "Parolni ko‘rsatish",
        hidePassword: "Parolni yashirish",
        loginError: "Kirishda xatolik yuz berdi",
        verifyError: "Hisobingiz tasdiqlanmagan. Iltimos, administratorga bog'laning.",
        invalidCredentials: "Email yoki parol noto‘g‘ri (yoki email hali tasdiqlanmagan).",
        cancel: "Bekor qilish",
        save: "Saqlash",
        saving: "Saqlanmoqda...",
        saveError: "Saqlashda xatolik",

        // --- Home Page ---
        premiumQuality: "Premium Sifat",
        heroTitle: "Uyingizga Hashamat Ulashing",
        heroSubtitle: "Yashash joyingizni dizayn va qulaylik durdonasiga aylantiruvchi eksklyuziv parda aksessuarlari.",
        shopNow: "Xaridni Boshlash",
        viewCatalog: "Katalogni Ko'rish",

        // Benefits
        fastDelivery: "Tez Yetkazib Berish",
        freeShipping: "Bepul Yetkazib Berish",
        qualityGuarantee: "Sifat Kafolati",
        securePayment: "xavfsiz To'lov",
        fastServiceDesc: "Buyurtmangiz 24 soat ichida yetkaziladi",
        freeDeliveryDesc: "500$ dan yuqori buyurtmalar uchun Toshkent ichida bepul",
        warrantyDesc: "Barcha mahsulotlarga 2 yillik kafolat",
        easyPaymentDesc: "Humo, Uzcard va Visa orqali to'lov",
        support247Desc: "Kuniga 24 soat aloqadamiz",
        bonusProgramDesc: "Har bir xarid uchun bonuslar",

        shopByCategory: "Kategoriyalar bo'yicha",
        bestSellers: "Eng Ko'p Sotilganlar",
        joinCommunity: "Dizaynerlar safiga qo'shiling",

        // --- SEO Meta ---
        metaDescHome: "Premium parda aksessuarlari - uyingizga hashamat va qulaylik. Sifatli mahsulotlar, tez yetkazib berish.",
        metaDescShop: "Parda aksessuarlari katalogi - turli rang va dizaynlarda. Onlayn xarid.",
        metaDescAbout: "Nuur Home Collection - premium parda aksessuarlari ishlab chiqaruvchi. Kompaniya haqida.",
        metaDescContact: "Biz bilan bog'laning. Savollaringiz uchun aloqa formalari va kontakt ma'lumotlari.",
        metaDescCart: "Savat - tanlangan mahsulotlaringiz. Xaridni davom ettiring.",
        metaDescCheckout: "To'lov - buyurtma ma'lumotlarini kiriting va buyurtmani tasdiqlang.",
        metaDescNotFound: "Sahifa topilmadi. Bosh sahifaga qayting.",
        notFoundTitle: "Sahifa topilmadi",
        errorBoundaryTitle: "Nimadir noto'g'ri ketdi",
        errorBoundaryDesc: "Uzr, sahifa yuklanayotganda xatolik yuz berdi. Qayta urinib ko'ring.",
        retry: "Qayta urinish",
        metaDescProduct: "Mahsulot tafsilotlari - narx, rang, tavsif. Savatga qo'shish.",
        metaDescOrders: "Mening buyurtmalarim - buyurtma tarixi va holati.",
        profile: "Profilim",
        wishlist: "Yoqtirilganlar",
        viewAll: "Barchasini ko'rish",
        viewAllOrders: "Barcha buyurtmalar",
        comingSoon: "Tez kunda",
        metaDescProfile: "Profil - yoqtirilganlar, buyurtmalar va ko'rib chiqqan mahsulotlar.",
        addAllToCart: "Barchasini savatga qo'shish",
        metaDescServices: "Xizmatlar - yetkazib berish, o'rnatish, maslahat.",
        metaDescShipping: "Yetkazib berish shartlari va narxlari.",
        metaDescReturns: "Qaytarish va almashish qoidalari.",
        metaDescFaq: "Ko'p so'raladigan savollar.",
        metaDescTerms: "Foydalanish shartlari.",
        metaDescPrivacy: "Maxfiylik siyosati.",

        // --- Footer ---
        footerDescription: "Uyingiz interyerini bizning premium parda aksessuarlarimiz bilan boyiting. Zamonaviy uylar uchun sifatli va didli mahsulotlar.",
        quickLinks: "Tezkor Havolalar",
        customerService: "Mijozlar Xizmati",
        // contactUs: "Bog'lanish", // duplicate
        // shipping: "Yetkazib berish", // duplicate
        returns: "Qaytarish va Almashish",
        faq: "Ko'p so'raladigan savollar",
        terms: "Foydalanish shartlari",
        privacy: "Maxfiylik siyosati",
        allRightsReserved: "Barcha huquqlar himoyalangan.",
        subscribeDesc: "Eksklyuziv takliflar va yangi dizaynlar haqida birinchi bo'lib bilish uchun obuna bo'ling.",
        subscribe: "Obuna Bo'lish",

        // --- Shop & Filter ---
        shopAll: "Barcha Mahsulotlar",
        filter: "Filter",
        clearFilters: "Filterni tozalash",
        noProducts: "Mahsulotlar topilmadi",
        items: "ta mahsulot",
        sortNewest: "Standart tartib (kod, nom)",
        sortPriceAsc: "Narx: pastdan yuqoriga",
        sortPriceDesc: "Narx: yuqoridan pastga",

        // --- Product Page ---
        backToShop: "Do'konga qaytish",
        back: "Ortga qaytish",
        close: "Yopish",
        addToCart: "Savatga",
        viewDetails: "To'liq ko'rish",
        buyNow: "Hozir Olish",
        description: "Tavsif",
        reviews: "Sharhlar",
        features: "Xususiyatlar",
        inStock: "Omborda mavjud",
        outOfStock: "Sotuvda yo'q",
        sku: "Kod",
        color: "Rangi",
        quantity: "Miqdor",
        relatedProducts: "O'xshash Mahsulotlar",
        recentlyViewed: "Oxirgi ko'rilgan mahsulotlar",
        share: "Ulashish",
        shareSuccess: "Muvaffaqiyatli ulashildi!",
        linkCopied: "Havola nusxalandi!",
        quickViewBtn: "Tez ko'rish",
        productCardImageDotsHint: "Rasm karuseli — rang namunasi emas",
        addToFavorites: "Sevimlilarga qo'shish",
        removeFromFavorites: "Sevimlilardan olib tashlash",

        // --- Cart ---
        checkout: "To'lov",
        emptyCart: "Savat bo'sh",
        emptyCartMessage: "Siz hali savatga hech narsa qo'shmadingiz. Mahsulotlar katalogini ko'zdan kechiring.",
        continueShopping: "Xaridni Davom Ettirish",
        orderSummary: "Buyurtma Xulosasi",
        subtotal: "Jami summa",
        cartNetto: "Netto",
        cartBrutto: "Brutto (kichik karobka)",
        cartMaster: "Katta karobka",
        cartGross: "Jami brutto",
        cartAllowance: "Taxminiy qo'shimcha",
        cartAllowanceNeedWeight: "Oraliq chiqishi uchun mahsulotga netto yoki brutto yozing.",
        cartAround: "Atrofida",
        cartTotalMaster: "Umumiy katta karobka",
        cartExact: "Aniq",
        cartUncertain: "Noaniq",
        cartExactHint: "Sig'imi yozilgan. Katta karobka soni o'zi chiqadi.",
        cartUncertainHint: "Sig'imi bo'sh. Nechta katta karobka ketganini yozing — vazn shundan chiqadi.",
        cartManualCount: "Katta karobka (dona)",
        cartManualKg: "Karobka o'zi (kg)",
        cartBoxSelf: "Karobka o'zi",
        cartManualHint: "Shu qismdagi mahsulotlar bitta katta karobkaga yig'iladi.",
        weightTon: "tonna",
        shipping: "Yetkazib berish",
        free: "Bepul",
        total: "Jami",
        thousand: "k",
        sum: "$",
        billingDetails: "To'lov Ma'lumotlari",
        adminQuickOrder: "Admin: checkout’siz buyurtma",
        adminQuickOrderTitle: "Tezkor buyurtma (admin)",
        adminQuickOrderHint:
            "To‘lov sahifasisiz buyurtma yaratiladi; ma’lumotlar CRM «Buyurtmalar» ro‘yxatiga veb-manbadagi buyurtmalar bilan bir qatorda tushadi.",
        adminQuickOrderSubmit: "Buyurtmani yaratish",
        adminQuickOrderCancel: "Bekor qilish",
        adminQuickOrderSuccess: "Buyurtma yaratildi. CRM da tekshiring.",
        adminQuickOrderPaymentLabel: "Sayt admini (checkout’siz)",
        adminCheckoutDisabledHint:
            "Admin akkaunt: odatiy to‘lov / chek sahifasi o‘chirilgan. Buyurtmani quyidagi tugma orqali yuboring.",
        adminCheckoutRedirectMessage: "Siz admin sifatida kirdingiz — sizni savatga yo‘naytirmoqdamiz. Buyurtmani u yerda «Admin» tugmasi bilan bering.",
        adminDownloadOrderPdf: "PDF yuklab olish",
        adminDownloadOrderPdfError: "PDF yaratishda xatolik. Internet yoki brauzer sozlamalarini tekshiring.",

        // --- Checkout ---
        personalInfo: "Shaxsiy Ma'lumotlar",
        deliveryInfo: "Yetkazib Berish",
        paymentMethod: "To'lov Usuli",
        phone: "Telefon",
        city: "Shahar",
        selectCity: "Shaharni tanlang",
        selectRegion: "Viloyatni tanlang",
        cityDistrict: "Shahar yoki tuman",
        locationOther: "Boshqa (qo'lda yozaman)",
        specifyRegionManual: "Viloyat / hudud (qo'lda)",
        specifyCityManual: "Shahar yoki tuman (qo'lda)",
        deliveryLocationHint: "Ro'yxatda yo'q bo'lsa «Boshqa»ni tanlang va yozing.",
        address: "Manzil",
        notes: "Izoh (ixtiyoriy)",
        regionRequired: "Viloyatni tanlang",
        region_tashkent_city: "Toshkent shahri",
        region_karakalpakstan: "Qoraqalpog'iston Respublikasi",
        region_andijan: "Andijon viloyati",
        region_bukhara: "Buxoro viloyati",
        region_fergana: "Farg'ona viloyati",
        region_jizzakh: "Jizzax viloyati",
        region_kashkadarya: "Qashqadaryo viloyati",
        region_navoi: "Navoiy viloyati",
        region_namangan: "Namangan viloyati",
        region_samarkand: "Samarqand viloyati",
        region_surkhandarya: "Surxondaryo viloyati",
        region_syrdarya: "Sirdaryo viloyati",
        region_tashkent: "Toshkent viloyati",
        region_khorezm: "Xorazm viloyati",
        jizzakh: "Jizzax",
        navoi: "Navoiy",
        termez: "Termiz",
        gulistan: "Guliston",
        chirchiq: "Chirchiq",
        angren: "Angren",
        urgench: "Urganch",
        tashkent: "Toshkent",
        samarkand: "Samarqand",
        bukhara: "Buxoro",
        andijan: "Andijon",
        namangan: "Namangan",
        fergana: "Farg'ona",
        nukus: "Nukus",
        karshi: "Qarshi",
        astana: "Ostona",
        almaty: "Almati",
        shymkent: "Chimkent",
        bishkek: "Bishkek",
        osh: "O'sh",
        dushanbe: "Dushanbe",
        khujand: "Xujand",
        ashgabat: "Ashxobod",
        istanbul: "Istanbul",
        ankara: "Anqara",
        dubai: "Dubay",
        abu_dhabi: "Abu Dabi",
        moscow: "Moskva",
        saint_petersburg: "Sankt-Peterburg",
        uploadReceipt: "To'lov chekini yuklash",
        maxFileSize: "Fayl hajmi 5MB dan oshmasligi kerak",
        confirmOrder: "Buyurtmani Tasdiqlash",
        processing: "Qayta ishlanmoqda...",
        orderSuccess: "Buyurtma Muvaffaqiyatli!",
        orderSuccessMsg: "Buyurtmangiz qabul qilindi. Tez orada operatorlarimiz bog'lanishadi.",
        redirecting: "Yönaltirilmoqda...",
        backToCart: "Savatga qaytish",
        error: "Xatolik",
        nameRequired: "Ism kiritilishi shart",
        nameMinLength: "Ism kamida 2 ta belgidan iborat bo'lishi kerak",
        emailRequired: "Email kiritilishi shart",
        passwordRequired: "Parol kiritilishi shart",
        loginUseEmailNotPhone:
            "Kirish faqat email orqali. Telefon raqamingizni «Email» maydoniga emas, ro‘yxatdan o‘tganda bergan email manzilingizni yozing.",
        loginPasswordNotPhoneHint:
            "«Parol» maydoniga telefon raqami emas, hisob parolingizni kiriting.",
        emailInvalid: "To'g'ri email kiriting",
        phoneInvalid: "To'g'ri telefon raqam kiriting",
        phoneMinDigits: "To'g'ri telefon raqam kiriting (kamida 9 ta raqam)",
        addressMinLength: "Manzil kamida 5 ta belgidan iborat bo'lishi kerak",
        cityRequired: "Shahar yoki tumanni tanlang",
        cityManualRequired: "Shahar/tuman nomini kiriting",
        regionManualRequired: "Viloyat/hudud nomini kiriting",
        receiptRequired: "Iltimos, to'lov chekini yuklang",
        checkoutLoginRequired: "Buyurtmani yakunlash uchun avval tizimga kiring.",
        checkoutLoginReturnHint: "Kirishdan keyin sizni yana shu sahifaga qaytaramiz.",
        cardNumberNotSet: "Karta raqami sozlanmagan",
        orderCreationFailed: "Buyurtma yaratilmadi. Qayta urinib ko'ring.",
        unknownError: "Noma'lum xatolik. Keyinroq urinib ko'ring.",
        messageRequired: "Xabar kiritilishi shart",
        messageMinLength: "Xabar kamida 10 ta belgidan iborat bo'lishi kerak",
        phoneRequired: "Telefon raqam shart",
        addressRequired: "Manzil shart",

        // --- About ---
        aboutTitle: "Biz Uyingizga Go'zallik Olib Kelamiz",
        aboutSubtitle: "Bizning maqsadimiz - har bir xonadon uchun zamonaviy va sifatli parda aksessuarlarini taqdim etish.",
        ourMission: "Bizning Missiyamiz",
        missionText1: "Biz kichik oilaviy biznes sifatida boshlandik va bugungi kunda interyer dizayni bo'yicha yetakchi kompaniyaga aylandik.",
        missionText2: "Mijozlarimizga hamyonbop narxlarda yuqori sifatli mahsulotlarni yetkazib berishdan faxrlanamiz.",
        ourValues: "Bizning Qadriyatlar",
        quality: "Yuqori Sifat",
        qualityDesc: "Faqat eng yaxshi materiallardan foydalanamiz.",
        service: "A'lo Xizmat",
        serviceDesc: "Mijozlar mamnuniyati biz uchun birinchi o'rinda.",
        innovation: "Innovatsiya",
        innovationDesc: "Doimo yangi va zamonaviy dizaynlarni izlaymiz.",
        happyCustomers: "Mamnun Mijozlar",
        yearsExperience: "Yillik Tajriba",
        productsAvailable: "Mahsulotlar",
        positiveReviews: "Ijobiy Sharhlar",

        // --- About Company (Nuur Home - Premium) ---
        aboutCompanyIntro: "Nuur Home Collection — 2017-yilda tashkil etilgan bo'lib, bugungi kunda parda aksessuarlari sohasida o'zining noyob uslubi va yuqori sifati bilan ajralib turuvchi brendga aylangan.",
        aboutCompanyPhilosophy: "Biz uchun har bir mahsulot — bu oddiy buyum emas, balki interyerning muhim detali, uy muhitiga nafislik va o'ziga xoslik bag'ishlovchi bezakdir. Shu sababli har bir mahsulotimiz chuqur o'ylangan dizayn, mukammal ishlov va sifatli materiallar asosida yaratiladi.",
        aboutCompanyMaterials: "Kolleksiyalarimiz yog'och, metall, ip, arqon hamda smola (resin) kabi yuqori sifatli xomashyolardan tayyorlanadi. Har bir detal zamonaviy dizayn tendensiyalari va mijozlar ehtiyojlari asosida ishlab chiqiladi.",
        aboutCompanyExperience: "Yillar davomida orttirilgan tajriba va mijozlar ishonchi bizni nafaqat O'zbekiston bozorida, balki MDH davlatlarida ham ishonchli hamkorga aylantirdi. Bugungi kunda biz eksport faoliyatini kengaytirib, xalqaro bozorda o'z o'rnimizni mustahkamlab bormoqdamiz.",
        aboutValuesTitle: "Bizning asosiy qadriyatlarimiz:",
        aboutValue1: "Mukammal sifat va detallar aniqligi",
        aboutValue2: "Eksklyuziv va zamonaviy dizayn",
        aboutValue3: "Mijozlarga individual yondashuv",
        aboutValue4: "Ishonchli va uzoq muddatli hamkorlik",
        aboutCompanyClosing: "Nuur Home Collection — interyeringizga nafislik, uslub va mukammallik olib kiradi.",

        // --- Contact ---
        sendMessage: "Xabar Yuborish",
        subject: "Mavzu",
        message: "Xabar",
        messageSent: "Xabar muvaffaqiyatli yuborildi!",
        mapPlaceholder: "Xarita",
        contactMapFallback: "Xarita uchun sozlamalarda koordinata yoki manzilni kiriting.",
        openInMaps: "Xaritada ochish",
        workingHours: "Ish vaqti",

        // --- Services ---
        needHelp: "Yordam kerakmi?",
        contactUsAnytime: "Bizning mutaxassislar bilan bog'laning va bepul maslahat oling.",
        contactUs: "Bog'lanish",
        bonusProgram: "Bonus Dasturi",
        subscribeSuccess: "Muvaffaqiyatli obuna bo'ldingiz!",
        alreadySubscribed: "Siz allaqachon a'zo bo'lgansiz!",
        loginToReview: "Sharh qoldirish uchun tizimga kiring",
        reviewSubmitted: "Sharhingiz qabul qilindi! Moderator tasdiqlagandan so'ng chiqadi.",
        errorMsg: "Xatolik yuz berdi. Iltimos qaytadan urinib ko'ring.",
        bulkOrder: "Bir nechta rangda buyurtma berish (Optom)",
        backToSingle: "← Yagona tanlovga qaytish",
        colorQuantity: "Ranglar bo'yicha miqdor:",
        addSelectedToCart: "Tanlanganlarni savatga qo'shish",
        itemsAddedToCart: "xil rang savatga qo'shildi!",
        selectAtLeastOneColor: "Kamida bitta rang uchun miqdor kiritishingiz kerak",
        leaveReview: "Sharh qoldirish",
        yourRating: "Bahoyingiz",
        yourReview: "Sharhingiz",
        reviewPlaceholder: "Mahsulot haqida fikringiz...",
        submit: "Yuborish",
        submitting: "Yuborilmoqda...",
        noReviews: "Hozircha sharhlar yo'q",
        noFeatures: "Xususiyatlar mavjud emas",
        myOrders: "Mening buyurtmalarim",
        orderHistory: "Buyurtmalar tarixi",
        orderId: "Buyurtma ID",
        date: "Sana",
        status: "Holati",
        noOrders: "Hozircha buyurtmalar mavjud emas",
        orderItems: "Buyurtma tarkibi",
        trackOrder: "Buyurtmani kuzatish",

        // --- Mijozlar Xizmati Sahifalari ---
        shippingIntro: "Quyida yetkazib berish joylari va muddatiga oid qisqa ma'lumot.",
        shippingRegionsTitle: "Yetkazib berish joylari",
        shippingRegionsText: "Biz O'zbekiston bo'ylab (Toshkent, viloyatlar), MDH davlatlari (Qozog'iston, Qirg'iziston, Tojikiston, Rossiya, Turkiya va boshqalar) hamda chet elga ishonchli kargo xizmati orqali yetkazib berish xizmatini taklif qilamiz. Yetkazib berish narxi va muddati manzilga qarab o'zgaradi.",
        shippingTimeTitle: "Yetkazib berish muddatiga",
        shippingTimeText: "Toshkent shahri ichida — 1-2 kun. Viloyatlar — 2-5 kun. MDH va chet el — 5-25 kun. Buyurtma tasdiqlangan vaqtdan boshlab hisoblanadi.",
        shippingCostTitle: "Yetkazib berish narxi",
        shippingCostText: "500$ dan yuqori buyurtmalar uchun Toshkent ichida bepul yetkazib berish. Viloyatlar va chet el uchun narx buyurtma summasi va manzilga qarab hisoblanadi. Operatorlarimiz buyurtma tasdiqlangach siz bilan bog'lanib, aniq narxni ma'lum qiladi.",
        shippingContact: "Savollaringiz bo'lsa, biz bilan bog'laning:",

        returnsIntro: "Sizning mamnuniyatingiz biz uchun muhim. Agar mahsulot sizni qoniqtirmasa, qaytarish va almashish imkoniyati mavjud.",
        returnsDeadlineTitle: "Qaytarish muddati",
        returnsDeadlineText: "Mahsulot yetkazib berilgan kundan boshlab 14 kun ichida qaytarish yoki almashish mumkin. Shikastlanmagan, ishlatilmagan va original qadoqda bo'lishi kerak.",
        returnsConditionsTitle: "Qaytarish shartlari",
        returnsConditionsText: "Mahsulot ishlatilmagan holatda, original qadoq va hujjatlari bilan qaytarilishi kerak. Maxsus buyurtma bo'yicha tayyorlangan mahsulotlar qaytarilmaydi.",
        returnsExchangeTitle: "Almashish",
        returnsExchangeText: "O'lcham yoki rang noto'g'ri bo'lsa, 14 kun ichida boshqa variantga almashish mumkin. Mahsulot omborda mavjud bo'lishi kerak.",
        returnsRefundTitle: "Pulni qaytarish",
        returnsRefundText: "Qaytarish tasdiqlangandan so'ng 5-10 ish kunida pul to'g'ridan-to'g'ri sizning karta yoki hisobingizga qaytariladi.",
        returnsContact: "Qaytarish yoki almashish uchun murojaat:",

        faqIntro: "Quyida mijozlarimiz ko'p beradigan savollarga javoblar.",
        faq1: "Buyurtmani qanday berish mumkin?",
        faq1Answer: "Mahsulotni tanlang, savatga qo'shing va to'ldirilgan forma orqali buyurtma bering. Operatorlarimiz tez orada siz bilan bog'lanadi.",
        faq2: "Qanday to'lov usullari mavjud?",
        faq2Answer: "Humo, Uzcard, Visa, Mastercard, Payme va naqd pul orqali to'lov qilish mumkin. Bank kartasi orqali to'lov xavfsiz.",
        faq3: "Yetkazib berish qancha vaqt davom etadi?",
        faq3Answer: "Toshkent shahri ichida — 1-2 kun, viloyatlar — 2-5 kun, MDH va chet el — 5-25 kun. Muddat buyurtma tasdiqlangan vaqtdan boshlab hisoblanadi. Batafsil vaqtni operator buyurtmani tasdiqlashda ma'lum qiladi.",
        faq4: "Bepul yetkazib berish shartlari qanday?",
        faq4Answer: "500$ dan yuqori buyurtmalar uchun Toshkent ichida yetkazib berish bepul. Viloyatlar va boshqa hududlar uchun narx alohida hisoblanadi.",
        faq5: "Mahsulotni qanday qaytarish mumkin?",
        faq5Answer: "14 kun ichida, ishlatilmagan va original qadoqda mahsulotni qaytarish mumkin. Operatorlarimizga murojaat qiling.",
        faq6: "Kafolat qancha vaqt davom etadi?",
        faq6Answer: "Barcha mahsulotlarimizga 2 yillik sifat kafolati beriladi. Ishlab chiqarish nuqsoni bo'lsa, bepul almashtiramiz yoki tuzatamiz.",
        faq7: "O'zbekistondan tashqariga yetkazib berasizmi?",
        faq7Answer: "Ha, MDH davlatlari, Turkiya, Yevropa va boshqa mamlakatlarga yetkazib beramiz. Yetkazib berish narxi va muddati manzilga qarab belgilanadi.",
        faq8: "Optom buyurtma berish mumkinmi?",
        faq8Answer: "Ha, optom buyurtma uchun alohida chegirma va shartnoma taklif qilamiz. Bog'lanish bo'limi orqali murojaat qiling.",

        termsIntro: "Saytdan foydalanishda quyidagi shartlarga rozilik bildirasiz.",
        terms1: "Sayt Nuur Home Collection tomonidan boshqariladi. Barcha materiallar va mahsulotlar kompaniya mulki hisoblanadi.",
        terms2: "Ro'yxatdan o'tish va hisob ma'lumotlari shaxsiy saqlanadi. Foydalanuvchi o'z parolini xavfsiz saqlashi shart.",
        terms3: "Buyurtma berishda kiritilgan ma'lumotlar to'g'ri bo'lishi kerak. Noto'g'ri ma'lumotlar sabab yuzaga kelgan zarar uchun mijoz javobgar.",
        terms4: "Mahsulot narxlari va mavjudligi ogohlantirishsiz o'zgarishi mumkin. Buyurtma tasdiqlanganda yakuniy narx qo'llaniladi.",
        terms5: "Saytda ko'rsatilgan barcha ma'lumotlar ma'lumot uchun. Kompaniya texnik xatoliklar uchun javobgar emas.",

        privacyIntro: "Shaxsiy ma'lumotlaringizni himoya qilish biz uchun muhim.",
        privacy1: "Biz ism, telefon, email, manzil kabi ma'lumotlarni faqat buyurtmani bajarish va mijozlar xizmati uchun to'playmiz.",
        privacy2: "To'plangan ma'lumotlar faqat xizmat ko'rsatish, reklama yuborish (rozilik bilan) va qonun talablariga javob berish uchun ishlatiladi.",
        privacy3: "Ma'lumotlaringizni uchinchi tomonlarga sotmaymiz. Faqat yetkazib berish hamkorlari bilan zarur ma'lumotlarni baham ko'ramiz.",
        privacy4: "Cookie va analytics vositalari sayt ishlashini yaxshilash uchun ishlatiladi. Brauzer sozlamalarida o'chirish mumkin.",
        privacy5: "Ma'lumotlaringizni ko'rish, o'zgartirish yoki o'chirish so'rovi uchun biz bilan bog'laning.",

        // Colors
        antratsit: "Antratsit",
        bej: "Bej",
        binafsha: "Binafsha",
        
        bordo: "Bordo",
        oq: "Oq",
        qora: "Qora",
        kulrang: "Kulrang",
        jigarrang: "Jigarrang",
        yashil: "Yashil",
        kok: "Ko'k",
        qizil: "Qizil",
        sariq: "Sariq",
        pushti: "Pushti",
        tillarang: "Tillarang",
        kumushrang: "Kumushrang"
    },

    ru: {
        // --- Header & Nav ---
        home: "Главная",
        shop: "Магазин",
        album: "Альбом",
        about: "О нас",
        services: "Услуги",
        contact: "Контакты",
        contactSubtitle: "У вас есть вопросы? Мы готовы помочь вам.",
        albumDesc: "Галерея новых моделей и примеры штор в интерьере. Нажмите на фото — откроется полный вид.",
        albumMetaDesc: "Галерея продукции Nuur Home и альбом моделей штор.",
        viewImage: "Смотреть фото",
        namePlaceholder: "Ваше имя",
        emailPlaceholder: "email@example.com",
        phonePlaceholder: "+998...",
        messagePlaceholder: "Как мы можем вам помочь?",
        categories: "Категории",
        curtainAccessories: "Аксессуары для Штор",
        cart: "Корзина",
        login: "Войти",
        register: "Регистрация",
        logout: "Выйти",
        search: "Поиск...",
        activeFilter: "Активный фильтр",
        allCategories: "Все категории",
        noAccount: "Нет аккаунта? Создать",
        haveAccount: "Есть аккаунт? Войти",
        authSwitchPromptLogin: "Нет аккаунта?",
        authSwitchPromptRegister: "Уже есть аккаунт?",
        loginSubmitting: "Вход...",
        registerSubmitting: "Регистрация...",
        forgotPassword: "Забыли пароль?",
        resetPasswordTitle: "Восстановление пароля",
        resetPasswordHint:
            "Введите email, указанный при регистрации. Мы отправим ссылку для сброса пароля.",
        resetPasswordSent:
            "Если аккаунт существует, на почту отправлена ссылка. Проверьте папку «Спам».",
        resetPasswordSubmit: "Отправить ссылку",
        recoveryNewPasswordTitle: "Новый пароль",
        recoveryNewPasswordHint:
            "Вы перешли по ссылке из письма. Введите новый пароль и сохраните.",
        backToLogin: "Назад ко входу",
        sending: "Отправка...",

        // --- Auth ---
        changePassword: "Сменить пароль",
        newPassword: "Новый пароль",
        passwordMinLength: "Пароль должен быть не короче 6 символов",
        name: "Имя",
        email: "Email",
        password: "Пароль",
        confirmPassword: "Подтвердите пароль",
        country: "Страна",
        selectCountry: "Выберите страну",
        uzbekistan: "Узбекистан",
        kazakhstan: "Казахстан",
        kyrgyzstan: "Киргизия",
        tajikistan: "Таджикистан",
        turkmenistan: "Туркменистан",
        turkey: "Турция",
        uae: "ОАЭ (Эмираты)",
        saudi_arabia: "Саудовская Аравия",
        qatar: "Катар",
        kuwait: "Кувейт",
        oman: "Оман",
        azerbaijan: "Азербайджан",
        russia: "Россия",
        china: "Китай",
        afghanistan: "Афганистан",
        armenia: "Армения",
        belarus: "Беларусь",
        georgia: "Грузия",
        india: "Индия",
        iran: "Иран",
        iraq: "Ирак",
        israel: "Израиль",
        jordan: "Иордания",
        lebanon: "Ливан",
        mongolia: "Монголия",
        pakistan: "Пакистан",
        palestine: "Палестина",
        syria: "Сирия",
        yemen: "Йемен",
        south_korea: "Южная Корея",
        japan: "Япония",
        vietnam: "Вьетнам",
        thailand: "Таиланд",
        malaysia: "Малайзия",
        singapore: "Сингапур",
        indonesia: "Индонезия",
        uk: "Великобритания",
        germany: "Германия",
        france: "Франция",
        italy: "Италия",
        spain: "Испания",
        netherlands: "Нидерланды",
        switzerland: "Швейцария",
        poland: "Польша",
        ukraine: "Украина",
        bangladesh: "Бангладеш",
        philippines: "Филиппины",
        enterName: "Введите ваше имя",
        passwordPlaceholder: "Введите пароль (мин. 6 символов)",
        confirmPasswordPlaceholder: "Повторите пароль",
        passwordMismatch: "Пароли не совпадают",
        showPassword: "Показать пароль",
        hidePassword: "Скрыть пароль",
        loginError: "Ошибка при входе",
        verifyError: "Ваш аккаунт не подтвержден. Пожалуйста, свяжитесь с администратором.",
        invalidCredentials: "Неверный email или пароль (или email ещё не подтверждён).",
        cancel: "Отмена",
        save: "Сохранить",
        saving: "Сохранение...",
        saveError: "Ошибка сохранения",

        // --- Home Page ---
        premiumQuality: "Премиум Качество",
        heroTitle: "Роскошь в Вашем Доме",
        heroSubtitle: "Эксклюзивные аксессуары для штор, которые превратят ваш интерьер в шедевр дизайна и комфорта.",
        shopNow: "Начать Покупки",
        viewCatalog: "Смотреть Каталог",

        // Benefits
        fastDelivery: "Быстрая Доставка",
        freeShipping: "Бесплатная Доставка",
        qualityGuarantee: "Гарантия Качества",
        securePayment: "Безопасная Оплата",
        fastServiceDesc: "Доставка вашего заказа в течение 24 часов",
        freeDeliveryDesc: "Бесплатно по Ташкенту при заказе от 500$",
        warrantyDesc: "2 года гарантии на все товары",
        easyPaymentDesc: "Оплата через Humo, Uzcard и Visa",
        support247Desc: "Мы на связи 24 часа в сутки",
        bonusProgramDesc: "Бонусы за каждую покупку",

        shopByCategory: "По Категориям",
        bestSellers: "Хиты Продаж",
        joinCommunity: "Присоединяйтесь к дизайнерам",

        // --- SEO Meta ---
        metaDescHome: "Премиальные аксессуары для штор - роскошь и комфорт для вашего дома. Качество и быстрая доставка.",
        metaDescShop: "Каталог аксессуаров для штор - разные цвета и дизайны. Онлайн-покупки.",
        metaDescAbout: "Nuur Home Collection - производитель премиальных аксессуаров для штор. О компании.",
        metaDescContact: "Свяжитесь с нами. Формы обратной связи и контакты для ваших вопросов.",
        metaDescCart: "Корзина - выбранные товары. Продолжить покупки.",
        metaDescCheckout: "Оформление заказа - введите данные и подтвердите заказ.",
        metaDescNotFound: "Страница не найдена. Вернитесь на главную.",
        notFoundTitle: "Страница не найдена",
        metaDescProduct: "Детали товара - цена, цвет, описание. Добавить в корзину.",
        metaDescOrders: "Мои заказы - история и статус заказов.",
        profile: "Мой профиль",
        wishlist: "Избранное",
        viewAll: "Смотреть все",
        viewAllOrders: "Все заказы",
        comingSoon: "Скоро",
        metaDescProfile: "Профиль - избранное, заказы и просмотренные товары.",
        addAllToCart: "Добавить все в корзину",
        metaDescServices: "Услуги - доставка, установка, консультации.",
        metaDescShipping: "Условия и стоимость доставки.",
        metaDescReturns: "Правила возврата и обмена.",
        metaDescFaq: "Часто задаваемые вопросы.",
        metaDescTerms: "Условия использования.",
        metaDescPrivacy: "Политика конфиденциальности.",

        // --- Error boundary ---
        errorBoundaryTitle: "Что-то пошло не так",
        errorBoundaryDesc: "Извините, при загрузке страницы произошла ошибка. Попробуйте обновить страницу.",
        retry: "Повторить",

        // --- Footer ---
        footerDescription: "Улучшите интерьер вашего дома с нашими премиальными аксессуарами для штор. Качество и стиль для современных домов.",
        quickLinks: "Быстрые ссылки",
        customerService: "Служба поддержки",
        // contactUs: "Контакты", // duplicate
        // shipping: "Доставка", // duplicate
        returns: "Возврат и Обмен",
        faq: "Часто задаваемые вопросы",
        terms: "Условия использования",
        privacy: "Политика конфиденциальности",
        allRightsReserved: "Все права защищены.",
        subscribeDesc: "Подпишитесь, чтобы первыми узнавать об эксклюзивных предложениях и новых дизайнах.",
        subscribe: "Подписаться",

        // --- Shop & Filter ---
        shopAll: "Все Товары",
        filter: "Фильтр",
        clearFilters: "Очистить фильтры",
        noProducts: "Товары не найдены",
        items: "товаров",
        sortNewest: "Стандартный порядок (код, название)",
        sortPriceAsc: "Цена: по возрастанию",
        sortPriceDesc: "Цена: по убыванию",

        // --- Product Page ---
        backToShop: "Назад в магазин",
        back: "Назад",
        close: "Закрыть",
        addToCart: "В корзину",
        viewDetails: "Подробнее",
        buyNow: "Купить Cейчас",
        description: "Описание",
        reviews: "Отзывы",
        features: "Характеристики",
        inStock: "В наличии",
        outOfStock: "Нет в наличии",
        sku: "Артикул",
        color: "Цвет",
        quantity: "Количество",
        relatedProducts: "Похожие Товары",
        recentlyViewed: "Недавно просмотренные",
        share: "Поделиться",
        shareSuccess: "Успешно отправлено!",
        linkCopied: "Ссылка скопирована!",
        quickViewBtn: "Быстрый просмотр",
        productCardImageDotsHint: "Карусель фото — не образцы цвета",
        addToFavorites: "В избранное",
        removeFromFavorites: "Убрать из избранного",

        // --- Cart ---
        checkout: "Оформление заказа",
        emptyCart: "Корзина пуста",
        emptyCartMessage: "Вы еще ничего не добавили. Посмотрите наш каталог товаров.",
        continueShopping: "Продолжить Покупки",
        orderSummary: "Итог Заказа",
        subtotal: "Сумма",
        cartNetto: "Нетто",
        cartBrutto: "Брутто (малая коробка)",
        cartMaster: "Большая коробка",
        cartGross: "Итого брутто",
        cartAllowance: "Прибавка примерно",
        cartAllowanceNeedWeight: "Чтобы увидеть диапазон, укажите нетто или брутто у товара.",
        cartAround: "Около",
        cartTotalMaster: "Всего больших коробок",
        cartExact: "Точно",
        cartUncertain: "Примерно",
        cartExactHint: "Вместимость указана. Число больших коробок считается само.",
        cartUncertainHint: "Вместимость пустая. Напишите, сколько больших коробок ушло — вес посчитается от этого.",
        cartManualCount: "Большая коробка (шт.)",
        cartManualKg: "Сама коробка (кг)",
        cartBoxSelf: "Сама коробка",
        cartManualHint: "Товары этого списка собраны в общие большие коробки.",
        weightTon: "тонна",
        shipping: "Доставка",
        free: "Бесплатно",
        total: "Итого",
        thousand: "тыс.",
        sum: "$",
        billingDetails: "Детали Оплаты",
        adminQuickOrder: "Админ: заказ без оформления",
        adminQuickOrderTitle: "Быстрый заказ (админ)",
        adminQuickOrderHint:
            "Заказ создаётся без страницы оплаты и попадает в CRM в общий список заказов с сайта.",
        adminQuickOrderSubmit: "Создать заказ",
        adminQuickOrderCancel: "Отмена",
        adminQuickOrderSuccess: "Заказ создан. Проверьте в CRM.",
        adminQuickOrderPaymentLabel: "Админ сайта (без оформления)",
        adminCheckoutDisabledHint:
            "Аккаунт админа: обычная страница оплаты и чека отключена. Оформите заказ кнопкой ниже.",
        adminCheckoutRedirectMessage:
            "Вы вошли как администратор — перенаправляем в корзину. Оформите заказ там кнопкой «Админ».",
        adminDownloadOrderPdf: "Скачать PDF",
        adminDownloadOrderPdfError: "Не удалось создать PDF. Проверьте сеть или настройки браузера.",

        // --- Checkout ---
        personalInfo: "Личные Данные",
        deliveryInfo: "Доставка",
        paymentMethod: "Способ Оплаты",
        phone: "Телефон",
        city: "Город",
        selectCity: "Выберите город",
        selectRegion: "Выберите область",
        cityDistrict: "Город или район",
        locationOther: "Другое (ввести вручную)",
        specifyRegionManual: "Область / регион (вручную)",
        specifyCityManual: "Город или район (вручную)",
        deliveryLocationHint: "Если нет в списке — выберите «Другое» и укажите.",
        address: "Адрес",
        notes: "Примечание (необязательно)",
        region_tashkent_city: "г. Ташкент",
        region_karakalpakstan: "Республика Каракалпакстан",
        region_andijan: "Андижанская область",
        region_bukhara: "Бухарская область",
        region_fergana: "Ферганская область",
        region_jizzakh: "Джизакская область",
        region_kashkadarya: "Кашкадарьинская область",
        region_navoi: "Навоийская область",
        region_namangan: "Наманганская область",
        region_samarkand: "Самаркандская область",
        region_surkhandarya: "Сурхандарьинская область",
        region_syrdarya: "Сырдарьинская область",
        region_tashkent: "Ташкентская область",
        region_khorezm: "Хорезмская область",
        jizzakh: "Джизак",
        navoi: "Навои",
        termez: "Термез",
        gulistan: "Гулистан",
        chirchiq: "Чирчик",
        angren: "Ангрен",
        urgench: "Ургенч",
        tashkent: "Ташкент",
        samarkand: "Самарканд",
        bukhara: "Бухара",
        andijan: "Андижан",
        namangan: "Наманган",
        fergana: "Фергана",
        nukus: "Нукус",
        karshi: "Карши",
        astana: "Астана",
        almaty: "Алматы",
        shymkent: "Шымкент",
        bishkek: "Бишкек",
        osh: "Ош",
        dushanbe: "Душанбе",
        khujand: "Худжанд",
        ashgabat: "Ашхабад",
        istanbul: "Стамбул",
        ankara: "Анкара",
        dubai: "Дубай",
        abu_dhabi: "Абу-Даби",
        moscow: "Москва",
        saint_petersburg: "Санкт-Петербург",
        uploadReceipt: "Загрузить чек оплаты",
        maxFileSize: "Размер файла не более 5МБ",
        confirmOrder: "Подтвердить Заказ",
        processing: "Обработка...",
        orderSuccess: "Заказ Оформлен!",
        orderSuccessMsg: "Ваш заказ успешно принят. Наши операторы свяжутся с вами в ближайшее время.",
        redirecting: "Перенаправление...",
        backToCart: "Назад в корзину",
        error: "Ошибка",
        nameRequired: "Имя обязательно",
        nameMinLength: "Имя должно быть не менее 2 символов",
        phoneRequired: "Телефон обязателен",
        phoneInvalid: "Введите корректный номер телефона",
        phoneMinDigits: "Введите корректный номер (минимум 9 цифр)",
        addressRequired: "Адрес обязателен",
        addressMinLength: "Адрес должен быть не менее 5 символов",
        cityRequired: "Выберите город или район",
        cityManualRequired: "Укажите город или район",
        regionRequired: "Выберите область",
        regionManualRequired: "Укажите область / регион",
        emailRequired: "Email обязателен",
        passwordRequired: "Введите пароль",
        loginUseEmailNotPhone:
            "Вход только по email. Не указывайте телефон в поле Email — введите адрес почты, указанный при регистрации.",
        loginPasswordNotPhoneHint:
            "В поле «Пароль» нужен пароль аккаунта, а не номер телефона.",
        emailInvalid: "Введите корректный email",
        receiptRequired: "Загрузите чек об оплате",

        checkoutLoginRequired: "Чтобы оформить заказ, сначала войдите в систему.",
        checkoutLoginReturnHint: "После входа мы вернём вас на эту страницу.",
        cardNumberNotSet: "Номер карты не задан",
        orderCreationFailed: "Не удалось создать заказ. Попробуйте снова.",
        unknownError: "Неизвестная ошибка. Попробуйте позже.",

        // --- About ---
        aboutTitle: "Мы Приносим Красоту в Ваш Дом",
        aboutSubtitle: "Наша цель - предоставить стильные и качественные аксессуары для штор для каждого дома.",
        ourMission: "Наша Миссия",
        missionText1: "Мы начинали как малый семейный бизнес и выросли в ведущую компанию в области дизайна интерьера.",
        missionText2: "Мы гордимся тем, что поставляем высококачественную продукцию по доступным ценам.",
        ourValues: "Наши Ценности",
        quality: "Высокое Качество",
        qualityDesc: "Используем только лучшие материалы.",
        service: "Отличный Сервис",
        serviceDesc: "Удовлетворение клиентов - наш приоритет.",
        innovation: "Инновации",
        innovationDesc: "Постоянно ищем новые и современные дизайны.",
        happyCustomers: "Довольных Клиентов",
        yearsExperience: "Лет Опыта",
        productsAvailable: "Товаров",
        positiveReviews: "Позитивных Отзывов",

        // --- About Company (Nuur Home - Premium) ---
        aboutCompanyIntro: "Nuur Home Collection — бренд, основанный в 2017 году, который сегодня занимает уверенные позиции в сфере производства аксессуаров для штор благодаря своему уникальному стилю и высокому качеству.",
        aboutCompanyPhilosophy: "Для нас каждый продукт — это не просто изделие, а важный элемент интерьера, создающий атмосферу уюта, стиля и гармонии. Именно поэтому каждая деталь разрабатывается с особым вниманием к дизайну, качеству и эстетике.",
        aboutCompanyMaterials: "Наши коллекции изготавливаются из высококачественных материалов: дерева, металла, текстиля, канатов и смолы (resin). Мы сочетаем современные дизайнерские тенденции с практичностью и долговечностью.",
        aboutCompanyExperience: "За годы работы компания завоевала доверие клиентов не только в Узбекистане, но и на рынках стран СНГ. Сегодня мы активно развиваем экспорт и укрепляем позиции на международном уровне.",
        aboutValuesTitle: "Наши ключевые ценности:",
        aboutValue1: "Безупречное качество",
        aboutValue2: "Эксклюзивный дизайн",
        aboutValue3: "Индивидуальный подход к клиентам",
        aboutValue4: "Надёжное партнёрство",
        aboutCompanyClosing: "Nuur Home Collection — элегантность и стиль в каждой детали вашего интерьера.",

        // --- Contact ---
        sendMessage: "Отправить Сообщение",
        subject: "Тема",
        message: "Сообщение",
        messageSent: "Сообщение успешно отправлено!",
        mapPlaceholder: "Карта",
        contactMapFallback: "Укажите координаты или адрес в настройках, чтобы показать карту.",
        openInMaps: "Открыть на карте",
        workingHours: "Режим работы",

        // --- Services ---
        needHelp: "Нужна помощь?",
        contactUsAnytime: "Свяжитесь с нашими специалистами и получите бесплатную консультацию.",
        contactUs: "Связаться",
        bonusProgram: "Бонусная Программа",
        subscribeSuccess: "Вы успешно подписались!",
        alreadySubscribed: "Вы уже подписаны!",
        loginToReview: "Пожалуйста, войдите, чтобы оставить отзыв",
        reviewSubmitted: "Ваш отзыв принят! Он появится после подтверждения модератором.",
        errorMsg: "Произошла ошибка. Пожалуйста, попробуйте еще раз.",
        bulkOrder: "Заказать в нескольких цветах (Оптом)",
        backToSingle: "← Назад к единичному выбору",
        colorQuantity: "Кол-во по цветам:",
        addSelectedToCart: "Добавить выбранное в корзину",
        itemsAddedToCart: "цветов добавлено в корзину!",
        selectAtLeastOneColor: "Нужно ввести количество хотя бы для одного цвета",
        leaveReview: "Оставить отзыв",
        yourRating: "Ваша оценка",
        yourReview: "Ваш отзыв",
        reviewPlaceholder: "Ваше мнение о товаре...",
        submit: "Отправить",
        submitting: "Отправка...",
        noReviews: "Отзывов пока нет",
        noFeatures: "Характеристики отсутствуют",
        myOrders: "Мои заказы",
        orderHistory: "История заказов",
        orderId: "ID заказа",
        date: "Дата",
        status: "Статус",
        noOrders: "Заказов пока нет",
        orderItems: "Состав заказа",
        trackOrder: "Отследить заказ",

        // --- Mijozlar Xizmati Sahifalari (RU) ---
        shippingIntro: "Ниже краткая информация о зонах доставки и сроках.",
        shippingRegionsTitle: "Регионы доставки",
        shippingRegionsText: "Мы предлагаем доставку по Узбекистану (Ташкент, области), в страны СНГ (Казахстан, Кыргызстан, Таджикистан, Россия, Турция и др.) и за рубеж через надёжные курьерские и карго-службы. Стоимость и срок зависят от адреса.",
        shippingTimeTitle: "Сроки доставки",
        shippingTimeText: "Внутри Ташкента — 1-2 дня. По областям — 2-5 дней. СНГ и за рубеж — 5-25 дней. Отсчёт с момента подтверждения заказа.",
        shippingCostTitle: "Стоимость доставки",
        shippingCostText: "Бесплатная доставка по Ташкенту при заказе от 500$. Для регионов и зарубежья стоимость рассчитывается по сумме заказа и адресу. После подтверждения заказа операторы свяжутся с вами и сообщат точную цену.",
        shippingContact: "Есть вопросы? Свяжитесь с нами:",

        returnsIntro: "Ваша удовлетворенность важна. Если товар не подошёл — возможен возврат или обмен.",
        returnsDeadlineTitle: "Срок возврата",
        returnsDeadlineText: "Возврат или обмен в течение 14 дней с момента получения. Товар должен быть неиспользованным, в оригинальной упаковке.",
        returnsConditionsTitle: "Условия возврата",
        returnsConditionsText: "Товар возвращается в неиспользованном виде с оригинальной упаковкой и документами. Товары по индивидуальному заказу возврату не подлежат.",
        returnsExchangeTitle: "Обмен",
        returnsExchangeText: "При неверном размере или цвете можно обменять в течение 14 дней. Товар должен быть в наличии.",
        returnsRefundTitle: "Возврат средств",
        returnsRefundText: "После подтверждения возврата средства поступят на вашу карту или счёт в течение 5-10 рабочих дней.",
        returnsContact: "По вопросам возврата или обмена:",

        faqIntro: "Ответы на частые вопросы клиентов.",
        faq1: "Как оформить заказ?",
        faq1Answer: "Выберите товар, добавьте в корзину и оформите заказ через форму. Оператор свяжется с вами в ближайшее время.",
        faq2: "Какие способы оплаты доступны?",
        faq2Answer: "Humo, Uzcard, Visa, Mastercard, Payme и наличными. Оплата картой безопасна.",
        faq3: "Сколько длится доставка?",
        faq3Answer: "Внутри Ташкента — 1-2 дня, по областям — 2-5 дней, СНГ и за рубеж — 5-25 дней. Срок отсчитывается с момента подтверждения заказа. Точное время сообщит оператор при подтверждении.",
        faq4: "Условия бесплатной доставки?",
        faq4Answer: "Бесплатная доставка по Ташкенту при заказе от 500$. Для областей и других регионов стоимость рассчитывается отдельно.",
        faq5: "Как вернуть товар?",
        faq5Answer: "В течение 14 дней можно вернуть неиспользованный товар в оригинальной упаковке. Обратитесь к операторам.",
        faq6: "Срок гарантии?",
        faq6Answer: "На все товары — 2 года гарантии. При заводском браке — бесплатная замена или ремонт.",
        faq7: "Доставляете за пределы Узбекистана?",
        faq7Answer: "Да, доставляем в страны СНГ, Турцию, Европу и другие государства. Стоимость и срок зависят от адреса.",
        faq8: "Можно заказать оптом?",
        faq8Answer: "Да, оптовым заказам — специальные скидки и условия. Свяжитесь через раздел Контакты.",

        termsIntro: "Используя сайт, вы соглашаетесь с данными условиями.",
        terms1: "Сайт управляется Nuur Home Collection. Все материалы и товары — собственность компании.",
        terms2: "Данные аккаунта конфиденциальны. Пользователь обязан хранить пароль в безопасности.",
        terms3: "При оформлении заказа данные должны быть верными. За ущерб из-за неверных данных отвечает клиент.",
        terms4: "Цены и наличие могут меняться без предупреждения. При подтверждении действует итоговая цена.",
        terms5: "Вся информация на сайте — справочная. Компания не несёт ответственности за технические сбои.",

        privacyIntro: "Защита ваших данных важна для нас.",
        privacy1: "Собираем имя, телефон, email, адрес только для оформления заказа и обслуживания.",
        privacy2: "Данные используются для обслуживания, рассылки (с согласия) и соблюдения закона.",
        privacy3: "Не продаём данные третьим лицам. Делимся только с партнёрами доставки при необходимости.",
        privacy4: "Cookies и аналитика улучшают работу сайта. Можно отключить в настройках браузера.",
        privacy5: "Для запроса на просмотр, изменение или удаление данных — свяжитесь с нами.",

        // Colors
        antratsit: "Антрацит",
        bej: "Бежевый",
        binafsha: "Фиолетовый",
        bodom: "Миндальный",
        bordo: "Бордовый",
        oq: "Белый",
        qora: "Черный",
        kulrang: "Серый",
        jigarrang: "Коричневый",
        yashil: "Зеленый",
        kok: "Синий",
        qizil: "Красный",
        sariq: "Желтый",
        pushti: "Розовый",
        tillarang: "Золотистый",
        kumushrang: "Серебристый"
    },

    en: {
        // --- Header & Nav ---
        home: "Home",
        shop: "Shop",
        album: "Album",
        about: "About Us",
        services: "Services",
        contact: "Contact",
        contactSubtitle: "Have questions? We are here to help.",
        albumDesc: "Gallery of new models and curtain examples in interiors. Tap a photo to view it full size.",
        albumMetaDesc: "Nuur Home product gallery and curtain models album.",
        viewImage: "View Image",
        namePlaceholder: "Your Name",
        emailPlaceholder: "email@example.com",
        phonePlaceholder: "+998...",
        messagePlaceholder: "How can we help you?",
        categories: "Categories",
        curtainAccessories: "Curtain Accessories",
        cart: "Cart",
        login: "Login",
        register: "Register",
        logout: "Logout",
        search: "Search...",
        activeFilter: "Active filter",
        allCategories: "All categories",
        noAccount: "Don't have an account? Sign up",
        haveAccount: "Have an account? Login",
        authSwitchPromptLogin: "Don't have an account?",
        authSwitchPromptRegister: "Already have an account?",
        loginSubmitting: "Signing in...",
        registerSubmitting: "Registering...",
        forgotPassword: "Forgot password?",
        resetPasswordTitle: "Reset password",
        resetPasswordHint:
            "Enter the email you used to register. We will send you a password reset link.",
        resetPasswordSent:
            "If an account exists for this email, we sent a reset link. Check your spam folder.",
        resetPasswordSubmit: "Send reset link",
        recoveryNewPasswordTitle: "Set a new password",
        recoveryNewPasswordHint:
            "You opened the link from your email. Enter a new password and save.",
        backToLogin: "Back to login",
        sending: "Sending...",

        // --- Auth ---
        changePassword: "Change password",
        newPassword: "New password",
        passwordMinLength: "Password must be at least 6 characters",
        name: "Name",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
        country: "Country",
        selectCountry: "Select Country",
        uzbekistan: "Uzbekistan",
        kazakhstan: "Kazakhstan",
        kyrgyzstan: "Kyrgyzstan",
        tajikistan: "Tajikistan",
        turkmenistan: "Turkmenistan",
        turkey: "Turkey",
        uae: "UAE (Emirates)",
        saudi_arabia: "Saudi Arabia",
        qatar: "Qatar",
        kuwait: "Kuwait",
        oman: "Oman",
        azerbaijan: "Azerbaijan",
        russia: "Russia",
        china: "China",
        afghanistan: "Afghanistan",
        armenia: "Armenia",
        belarus: "Belarus",
        georgia: "Georgia",
        india: "India",
        iran: "Iran",
        iraq: "Iraq",
        israel: "Israel",
        jordan: "Jordan",
        lebanon: "Lebanon",
        mongolia: "Mongolia",
        pakistan: "Pakistan",
        palestine: "Palestine",
        syria: "Syria",
        yemen: "Yemen",
        south_korea: "South Korea",
        japan: "Japan",
        vietnam: "Vietnam",
        thailand: "Thailand",
        malaysia: "Malaysia",
        singapore: "Singapore",
        indonesia: "Indonesia",
        uk: "United Kingdom",
        germany: "Germany",
        france: "France",
        italy: "Italy",
        spain: "Spain",
        netherlands: "Netherlands",
        switzerland: "Switzerland",
        poland: "Poland",
        ukraine: "Ukraine",
        bangladesh: "Bangladesh",
        philippines: "Philippines",
        enterName: "Enter your name",
        passwordPlaceholder: "Enter password (min. 6 characters)",
        confirmPasswordPlaceholder: "Re-enter password",
        passwordMismatch: "Passwords do not match",
        showPassword: "Show password",
        hidePassword: "Hide password",
        loginError: "Login error",
        verifyError: "Your account is not verified. Please contact administrator.",
        invalidCredentials: "Invalid email or password (or email not confirmed yet).",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        saveError: "Could not save",

        // --- Home Page ---
        premiumQuality: "Premium Quality",
        heroTitle: "Bring Elegance to Your Home",
        heroSubtitle: "Exclusive curtain accessories that transform your living space into a masterpiece of design and comfort.",
        shopNow: "Shop Now",
        viewCatalog: "View Catalog",

        // Benefits
        fastDelivery: "Fast Delivery",
        freeShipping: "Free Shipping",
        qualityGuarantee: "Quality Guarantee",
        securePayment: "Secure Payment",
        fastServiceDesc: "Your order delivered within 24 hours",
        freeDeliveryDesc: "Free within Tashkent for orders over $500",
        warrantyDesc: "2-year warranty on all products",
        easyPaymentDesc: "Pay via Humo, Uzcard, and Visa",
        support247Desc: "We are available 24/7",
        bonusProgramDesc: "Bonuses for every purchase",

        shopByCategory: "Shop by Category",
        bestSellers: "Best Sellers",
        joinCommunity: "Join the designers",

        // --- SEO Meta ---
        metaDescHome: "Premium curtain accessories - luxury and comfort for your home. Quality products, fast delivery.",
        metaDescShop: "Curtain accessories catalog - various colors and designs. Shop online.",
        metaDescAbout: "Nuur Home Collection - premium curtain accessories manufacturer. About us.",
        metaDescContact: "Contact us. Feedback forms and contact information for your questions.",
        metaDescCart: "Cart - your selected items. Continue shopping.",
        metaDescCheckout: "Checkout - enter order details and confirm your order.",
        metaDescNotFound: "Page not found. Return to home.",
        notFoundTitle: "Page Not Found",
        errorBoundaryTitle: "Something went wrong",
        errorBoundaryDesc: "Sorry, an error occurred while loading the page. Please try again.",
        retry: "Try Again",
        metaDescProduct: "Product details - price, color, description. Add to cart.",
        metaDescOrders: "My Orders - order history and status.",
        profile: "My Profile",
        wishlist: "Wishlist",
        viewAll: "View All",
        viewAllOrders: "View All Orders",
        comingSoon: "Coming Soon",
        metaDescProfile: "Profile - wishlist, orders and recently viewed products.",
        addAllToCart: "Add All to Cart",
        metaDescServices: "Services - delivery, installation, consulting.",
        metaDescShipping: "Shipping terms and rates.",
        metaDescReturns: "Return and exchange policy.",
        metaDescFaq: "Frequently asked questions.",
        metaDescTerms: "Terms of use.",
        metaDescPrivacy: "Privacy policy.",

        // --- Footer ---
        footerDescription: "Elevate your interior with our premium curtain accessories. Quality craftsmanship for modern homes.",
        quickLinks: "Quick Links",
        customerService: "Customer Service",
        // contactUs: "Contact Us", // duplicate
        // shipping: "Shipping Policy", // duplicate
        returns: "Returns & Exchanges",
        faq: "FAQ",
        terms: "Terms & Conditions",
        privacy: "Privacy Policy",
        allRightsReserved: "All Rights Reserved.",
        subscribeDesc: "Subscribe to be the first to know about exclusive offers and new designs.",
        subscribe: "Subscribe",

        // --- Shop & Filter ---
        shopAll: "All Products",
        filter: "Filter",
        clearFilters: "Clear filters",
        noProducts: "No products found",
        items: "items",
        sortNewest: "Default order (code, name)",
        sortPriceAsc: "Price: low to high",
        sortPriceDesc: "Price: high to low",

        // --- Product Page ---
        backToShop: "Back to Shop",
        back: "Back",
        close: "Close",
        addToCart: "Add to Cart",
        viewDetails: "View Details",
        buyNow: "Buy Now",
        description: "Description",
        reviews: "Reviews",
        features: "Features",
        inStock: "In Stock",
        outOfStock: "Out of Stock",
        sku: "SKU",
        color: "Color",
        quantity: "Quantity",
        relatedProducts: "Related Products",
        recentlyViewed: "Recently Viewed",
        share: "Share",
        shareSuccess: "Shared successfully!",
        linkCopied: "Link copied!",
        quickViewBtn: "Quick view",
        productCardImageDotsHint: "Photo carousel — not color swatches",
        addToFavorites: "Add to favorites",
        removeFromFavorites: "Remove from favorites",

        // --- Cart ---
        checkout: "Checkout",
        emptyCart: "Cart is Empty",
        emptyCartMessage: "You haven't added anything to your cart yet. Browse our catalog.",
        continueShopping: "Continue Shopping",
        orderSummary: "Order Summary",
        subtotal: "Subtotal",
        cartNetto: "Net",
        cartBrutto: "Gross (inner box)",
        cartMaster: "Master carton",
        cartGross: "Total gross",
        cartAllowance: "Approx. extra",
        cartAllowanceNeedWeight: "Enter a net or gross weight on the product to see the range.",
        cartAround: "About",
        cartTotalMaster: "Total master cartons",
        cartExact: "Exact",
        cartUncertain: "Uncertain",
        cartExactHint: "Pack size is set. Master cartons are counted automatically.",
        cartUncertainHint: "Pack size is empty. Enter how many master cartons were used and the weight follows.",
        cartManualCount: "Master cartons (pcs)",
        cartManualKg: "Empty carton (kg)",
        cartBoxSelf: "Empty carton",
        cartManualHint: "These items are packed together into shared master cartons.",
        weightTon: "t",
        shipping: "Shipping",
        free: "Free",
        total: "Total",
        thousand: "k",
        sum: "$",
        billingDetails: "Billing Details",
        adminQuickOrder: "Admin: order without checkout",
        adminQuickOrderTitle: "Quick order (admin)",
        adminQuickOrderHint:
            "Creates the order without the payment page. It appears in CRM with other website orders.",
        adminQuickOrderSubmit: "Create order",
        adminQuickOrderCancel: "Cancel",
        adminQuickOrderSuccess: "Order created. Check in CRM.",
        adminQuickOrderPaymentLabel: "Site admin (no checkout)",
        adminCheckoutDisabledHint:
            "Admin account: the standard payment / receipt checkout is disabled. Use the button below to place the order.",
        adminCheckoutRedirectMessage:
            "You are signed in as an admin — redirecting to your cart. Place the order there with the Admin button.",
        adminDownloadOrderPdf: "Download PDF",
        adminDownloadOrderPdfError: "Could not create PDF. Check your network or browser settings.",

        // --- Checkout ---
        personalInfo: "Personal Information",
        deliveryInfo: "Delivery Information",
        paymentMethod: "Payment Method",
        phone: "Phone",
        city: "City",
        selectCity: "Select City",
        selectRegion: "Select region",
        cityDistrict: "City or district",
        locationOther: "Other (enter manually)",
        specifyRegionManual: "Region (manual)",
        specifyCityManual: "City or district (manual)",
        deliveryLocationHint: "If your place is not listed, choose Other and type it.",
        address: "Address",
        notes: "Notes (optional)",
        region_tashkent_city: "Tashkent city",
        region_karakalpakstan: "Republic of Karakalpakstan",
        region_andijan: "Andijan region",
        region_bukhara: "Bukhara region",
        region_fergana: "Fergana region",
        region_jizzakh: "Jizzakh region",
        region_kashkadarya: "Kashkadarya region",
        region_navoi: "Navoi region",
        region_namangan: "Namangan region",
        region_samarkand: "Samarkand region",
        region_surkhandarya: "Surkhandarya region",
        region_syrdarya: "Syrdarya region",
        region_tashkent: "Tashkent region",
        region_khorezm: "Khorezm region",
        jizzakh: "Jizzakh",
        navoi: "Navoi",
        termez: "Termez",
        gulistan: "Gulistan",
        chirchiq: "Chirchiq",
        angren: "Angren",
        urgench: "Urgench",
        tashkent: "Tashkent",
        samarkand: "Samarkand",
        bukhara: "Bukhara",
        andijan: "Andijan",
        namangan: "Namangan",
        fergana: "Fergana",
        nukus: "Nukus",
        karshi: "Karshi",
        astana: "Astana",
        almaty: "Almaty",
        shymkent: "Shymkent",
        bishkek: "Bishkek",
        osh: "Osh",
        dushanbe: "Dushanbe",
        khujand: "Khujand",
        ashgabat: "Ashgabat",
        istanbul: "Istanbul",
        ankara: "Ankara",
        dubai: "Dubai",
        abu_dhabi: "Abu Dhabi",
        moscow: "Moscow",
        saint_petersburg: "Saint Petersburg",
        uploadReceipt: "Upload Payment Receipt",
        maxFileSize: "File size must not exceed 5MB",
        confirmOrder: "Confirm Order",
        processing: "Processing...",
        orderSuccess: "Order Successful!",
        orderSuccessMsg: "Your order has been received. Our operators will contact you shortly.",
        redirecting: "Redirecting...",
        backToCart: "Back to Cart",
        error: "Error",
        nameRequired: "Name is required",
        nameMinLength: "Name must be at least 2 characters",
        phoneRequired: "Phone is required",
        phoneInvalid: "Enter a valid phone number",
        phoneMinDigits: "Enter a valid phone number (min 9 digits)",
        addressRequired: "Address is required",
        addressMinLength: "Address must be at least 5 characters",
        cityRequired: "Please select city or district",
        cityManualRequired: "Enter city or district",
        regionRequired: "Please select a region",
        regionManualRequired: "Enter region",
        emailRequired: "Email is required",
        passwordRequired: "Password is required",
        loginUseEmailNotPhone:
            "Sign-in is email-only. Don’t put your phone in the email field — use the email you registered with.",
        loginPasswordNotPhoneHint:
            "Use your account password in the password field, not your phone number.",
        emailInvalid: "Enter a valid email",
        receiptRequired: "Please upload payment receipt",

        checkoutLoginRequired: "Please sign in to complete your checkout.",
        checkoutLoginReturnHint: "After you sign in, we will bring you back here.",
        cardNumberNotSet: "Card number not configured",
        orderCreationFailed: "Could not create the order. Please try again.",
        unknownError: "Something went wrong. Please try again later.",

        // --- About ---
        aboutTitle: "We Bring Beauty to Your Home",
        aboutSubtitle: "Our goal is to provide stylish and high-quality curtain accessories for every home.",
        ourMission: "Our Mission",
        missionText1: "We started as a small family business and have grown into a leading company in interior design.",
        missionText2: "We are proud to deliver high-quality products at affordable prices to our customers.",
        ourValues: "Our Values",
        quality: "High Quality",
        qualityDesc: "We use only the best materials.",
        service: "Excellent Service",
        serviceDesc: "Customer satisfaction is our top priority.",
        innovation: "Innovation",
        innovationDesc: "Always looking for new and modern designs.",
        happyCustomers: "Happy Customers",
        yearsExperience: "Years Experience",
        productsAvailable: "Products",
        positiveReviews: "Positive Reviews",

        // --- About Company (Nuur Home - Premium) ---
        aboutCompanyIntro: "Nuur Home Collection, founded in 2017, is a premium brand specializing in high-quality curtain accessories, recognized for its unique style and exceptional craftsmanship.",
        aboutCompanyPhilosophy: "For us, each product is more than just an item — it is a refined element of interior design that enhances the atmosphere of a space with elegance and character. That is why every piece is created with great attention to detail, combining aesthetics, functionality, and durability.",
        aboutCompanyMaterials: "Our collections are crafted from carefully selected materials such as wood, metal, rope, textile, and resin, reflecting modern design trends while maintaining timeless appeal.",
        aboutCompanyExperience: "Over the years, the company has earned the trust of customers not only in Uzbekistan but also across CIS countries. Today, we are actively expanding our export geography and strengthening our presence in international markets.",
        aboutValuesTitle: "Our core values:",
        aboutValue1: "Exceptional quality and craftsmanship",
        aboutValue2: "Exclusive and modern design",
        aboutValue3: "Personalized customer approach",
        aboutValue4: "Reliable long-term partnership",
        aboutCompanyClosing: "Nuur Home Collection — bringing elegance and perfection into your interior.",

        // --- Contact ---
        sendMessage: "Send Message",
        subject: "Subject",
        message: "Message",
        messageSent: "Message sent successfully!",
        mapPlaceholder: "Map",
        contactMapFallback: "Add coordinates or address in site settings to show the map.",
        openInMaps: "Open in maps",
        workingHours: "Working Hours",

        // --- Services ---
        needHelp: "Need Help?",
        contactUsAnytime: "Contact our experts and get a free consultation.",
        contactUs: "Contact Us",
        bonusProgram: "Bonus Program",
        subscribeSuccess: "Successfully subscribed!",
        alreadySubscribed: "You are already subscribed!",
        loginToReview: "Please login to leave a review",
        reviewSubmitted: "Your review has been submitted! It will appear after moderator approval.",
        errorMsg: "An error occurred. Please try again.",
        bulkOrder: "Bulk order in multiple colors",
        backToSingle: "← Back to single choice",
        colorQuantity: "Quantity by color:",
        addSelectedToCart: "Add selected to cart",
        itemsAddedToCart: "colors added to cart!",
        selectAtLeastOneColor: "Please enter quantity for at least one color",
        leaveReview: "Leave a Review",
        yourRating: "Your Rating",
        yourReview: "Your Review",
        reviewPlaceholder: "Your thoughts about the product...",
        submit: "Submit",
        submitting: "Submitting...",
        noReviews: "No reviews yet",
        noFeatures: "No features available",
        myOrders: "My Orders",
        orderHistory: "Order History",
        orderId: "Order ID",
        date: "Date",
        status: "Status",
        noOrders: "No orders found",
        orderItems: "Order Items",
        trackOrder: "Track Order",

        // --- Customer Service Pages (EN) ---
        shippingIntro: "Below is a short overview of delivery areas and timeframes.",
        shippingRegionsTitle: "Delivery regions",
        shippingRegionsText: "We offer delivery across Uzbekistan (Tashkent, regions), CIS countries (Kazakhstan, Kyrgyzstan, Tajikistan, Russia, Turkey, etc.) and internationally via reliable cargo services. Cost and delivery time depend on the destination.",
        shippingTimeTitle: "Delivery timeframes",
        shippingTimeText: "Within Tashkent — 1-2 days. Regions — 2-5 days. CIS and international — 5-25 days. Counted from the moment the order is confirmed.",
        shippingCostTitle: "Shipping cost",
        shippingCostText: "Free delivery within Tashkent for orders over $500. For regions and abroad, the price is calculated from the order total and address. After your order is confirmed, our operators will contact you with the exact price.",
        shippingContact: "Questions? Contact us:",

        returnsIntro: "Your satisfaction matters. If a product doesn't meet your expectations, return or exchange is available.",
        returnsDeadlineTitle: "Return deadline",
        returnsDeadlineText: "Return or exchange within 14 days of delivery. Product must be unused, in original packaging.",
        returnsConditionsTitle: "Return conditions",
        returnsConditionsText: "Product must be returned unused, in original packaging with documents. Custom orders are not eligible for return.",
        returnsExchangeTitle: "Exchange",
        returnsExchangeText: "Wrong size or color? Exchange within 14 days if the variant is in stock.",
        returnsRefundTitle: "Refund",
        returnsRefundText: "After return approval, funds will be refunded to your card or account within 5-10 business days.",
        returnsContact: "For returns or exchanges:",

        faqIntro: "Answers to frequently asked questions.",
        faq1: "How do I place an order?",
        faq1Answer: "Select a product, add to cart, and complete the order form. Our operator will contact you shortly.",
        faq2: "What payment methods are available?",
        faq2Answer: "Humo, Uzcard, Visa, Mastercard, Payme, and cash. Card payment is secure.",
        faq3: "How long does delivery take?",
        faq3Answer: "Within Tashkent — 1-2 days, regions — 2-5 days, CIS and international — 5-25 days. Counted from the moment the order is confirmed. The operator will confirm exact timing when the order is approved.",
        faq4: "What are the conditions for free shipping?",
        faq4Answer: "Free delivery within Tashkent for orders over $500. For regions and other areas, shipping is calculated separately.",
        faq5: "How do I return a product?",
        faq5Answer: "Within 14 days you can return an unused product in original packaging. Contact our operators.",
        faq6: "What is the warranty period?",
        faq6Answer: "All products come with a 2-year quality warranty. Manufacturing defects — free replacement or repair.",
        faq7: "Do you deliver outside Uzbekistan?",
        faq7Answer: "Yes, we deliver to CIS countries, Turkey, Europe, and other countries. Cost and timing depend on the destination.",
        faq8: "Can I order in bulk?",
        faq8Answer: "Yes, we offer special discounts and terms for bulk orders. Contact us via the Contact section.",

        termsIntro: "By using this site you agree to the following terms.",
        terms1: "This site is operated by Nuur Home Collection. All content and products are company property.",
        terms2: "Account data is kept confidential. User must keep password secure.",
        terms3: "Order details must be accurate. Customer is liable for damage caused by incorrect information.",
        terms4: "Prices and availability may change without notice. Final price applies at confirmation.",
        terms5: "All information on the site is for reference. Company is not liable for technical errors.",

        privacyIntro: "Protecting your data is important to us.",
        privacy1: "We collect name, phone, email, address only for order processing and customer service.",
        privacy2: "Data is used for service, marketing (with consent), and legal compliance.",
        privacy3: "We do not sell data to third parties. We share only with delivery partners when necessary.",
        privacy4: "Cookies and analytics improve site performance. Can be disabled in browser settings.",
        privacy5: "To request view, change, or deletion of your data — contact us.",

        // Colors
        antratsit: "Anthracite",
        bej: "Beige",
        binafsha: "Purple",
        bodom: "Almond",
        bordo: "Bordeaux",
        oq: "White",
        qora: "Black",
        kulrang: "Grey",
        jigarrang: "Brown",
        yashil: "Green",
        kok: "Blue",
        qizil: "Red",
        sariq: "Yellow",
        pushti: "Pink",
        tillarang: "Gold",
        kumushrang: "Silver"
    }
};
